import classnames from 'classnames';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import React from 'react';

// Dynamically import with SSR disabled
const Carousel = dynamic(() => import('../../components/interactive/Carousel'), { ssr: false });

type UseCasesShowcaseProps = {
  orientation: 'left' | 'right';
  title: string;
  description?: string;
  descriptionList?: string[];
  tags?: string[];
  imageUrl: string;
};
const UseCasesShowcase: React.FC<UseCasesShowcaseProps> = React.memo((props) => {
  const { title, description, descriptionList, tags, orientation, imageUrl } = props;
  return (
    <div className="max-w-6xl mx-auto">
      <div
        className={classnames('flex flex-col bg  gap-6 items-center justify-items-center my-6', {
          'md:flex-row': orientation === 'left',
          'md:flex-row-reverse': orientation === 'right',
        })}
      >
        <div className="w-full md:w-1/2 items-center justify-center flex">
          <Image src={imageUrl} alt="Gaspar product preview" width={400} height={200} />
        </div>
        <div className="w-full md:w-1/2">
          <h2 className="text-section-title mb-4 leading-none">{title}</h2>
          {description && <p className="text-lg">{description}</p>}
          {descriptionList && (
            <ul className="list-disc ml-4 text-lg">
              {descriptionList.map((entry, index) => (
                <li className="mb-1" key={index}>
                  {entry}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className="flex justify-center items-center">
        <Carousel
          width={1000}
          autoChangeWaitTimeMS={5000}
          panels={(tags || []).map((tag, index) => (
            <TagsCarouselPanel key={index} tagIndex={index} tag={tag} />
          ))}
        />
      </div>
    </div>
  );
});
UseCasesShowcase.displayName = 'UseCasesShowcase';
export default UseCasesShowcase;

/************************************************************************************************
 * Helpers
 ************************************************************************************************/

type TagsCarouselPanelProps = { tag: string; tagIndex: number };
const TagsCarouselPanel: React.FC<TagsCarouselPanelProps> = React.memo((props) => {
  const { tag, tagIndex } = props;
  return (
    <div
      className={classnames(
        'p-3 w-[90vw] md:w-[300px] text-2xl md:text-xl text-center md:text-left inline-block font-bold text-pureWhite rounded-xl',
        {
          'bg-pureWhite/10': tagIndex % 2 === 0,
          'bg-black border-gray/20 border-1': tagIndex % 2 !== 0,
        },
      )}
    >
      {tag}
    </div>
  );
});
TagsCarouselPanel.displayName = 'TagsCarouselPanel';
